import hotkeys from 'hotkeys-js';
import { useEffect } from 'react';
import { useUniqueId } from './useUniqueId.js';

const appliedListenersMap = new Map();
const useShortcut = (command, listener, args) => {
  const listenerId = useUniqueId();
  useEffect(() => {
    if (!args.enabled || command === undefined || listener === undefined) {
      return;
    }
    const usingPlus = command.includes("-+");
    const appliedCommand = usingPlus ? command.replace("-+", "+*") : command;
    if (!appliedListenersMap.has(command)) {
      appliedListenersMap.set(command, new Set());
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const appliedListeners = appliedListenersMap.get(command);
    appliedListeners.add(listenerId);
    const shortcutHandler = evt => {
      if (listenerId !== getLastAddedItem(appliedListeners)) {
        // only the last applied shortcut listener may be triggered in a
        // single command; otherwise we could accidentally close multiple layers
        // of ui at once even if that's not what the user intended to do
        return;
      }
      if (usingPlus && evt.key !== "+") {
        // we're working around the fact that hotkeys-js doesn't support plus
        // natively by replacing with an asterisk in the applied command;
        // therefore we now need to explicitly verify that the shortcut is only
        // applied when plus is actually pressed
        return;
      }
      listener(evt);
    };
    hotkeys(appliedCommand, shortcutHandler);

    // We also want our shortcuts to apply while inputs, selects etc. are
    // focused.
    hotkeys.filter = () => true;
    return () => {
      hotkeys.unbind(appliedCommand, shortcutHandler);
      appliedListeners.delete(listenerId);
    };
  }, [args.enabled, command, listener, listenerId]);
};
function getLastAddedItem(set) {
  const values = set.values();
  let prevValue;
  let currValue;
  do {
    prevValue = currValue;
    currValue = values.next();
  } while (currValue.done !== true);
  if (prevValue !== undefined) {
    return prevValue.value;
  }
}

export { useShortcut };
//# sourceMappingURL=useShortcut.js.map
